export default __webpack_public_path__ + "static/media/KZ.M.16.2210 black.4de05cc6.svg";